import keymirror from "keymirror";

export default keymirror({
  SET_ORGANIZATION_MANIFESTS: null,
  REPLACE_ORGANIZATION_MANIFESTS: null,
  UPDATE_ORGANIZATION_MANIFEST_STORE: null
});
